import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import LoginBottomBanner from "../../assets/loginBottomBanner.png";
import Banner from "../../assets/svg/LoginTempleBanner.svg";
import TextField from "@mui/material/TextField";
import { ClipLoader } from "react-spinners";
import FormControlLabel from "@mui/material/FormControlLabel";
import constants from "../../config/constants.json";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCloseIcon,
  CustomInputLabel,
  CustomRequiredInputLabel,
  CustomPasswordTextFeild,
} from "../common/StyledComponents/StyledFields";
import commonStyles from "../../../App.module.scss";
import styles from "./login.module.scss";
import Checkbox from "@mui/material/Checkbox";
import { Box, Link, styled } from "@mui/material";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router";
import ForgotPassword from "./forgotPassword";
import ForgotUsername from "./forgotUsername";
import { apiRequest, catchErrorMessageHandler } from "../../infrastructure/backendService";
import toast, { Toaster } from "react-hot-toast";
import ToastError from "../common/toast/toastError";
import ToastSuccess from "../common/toast/toastSuccess";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { isNil } from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";
import loginBgBanner from "../../assets/loginBgBanner.png";
import apiPath from "../../config/apiPaths.json";
import { roleListProps } from "../../infrastructure/GlobalContextProvider";
import ErrorPopup from "../common/ErrorPopup";
import { RoutingURLs, SubRoutingURLs } from "../common/RoutingURLs";

interface LoginRightBannerProps {
  handleDonateClick?: () => void;
  setLoginOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}
interface loginProps {
  handleClickDonation?: () => void;
}
export const loginScreen = {
  bannerStyle: {
    backgroundImage: `url(${Banner})`,
    height: "100%",
    width: "100%",
    borderRadius: "20px",
    color: `#ffffff`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  bottomBanner: {
    backgroundImage: `url(${LoginBottomBanner})`,
    width: "100%",
    color: `#F05802`,
    position: "absolute",
    backgroundSize: "cover",
  },
  contentPadding: {
    padding: "40px",
  },
  formPadding: {
    padding: "0 80px 0 0",
    boxSize: "border-box",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  },
  buttonSize: {
    height: "38px",
    width: "100%",
    marginTop: "15px",
  },
  userForm: {
    height: "100%",
  },
  userFormContent: {},
};

export const CustomTextField = styled(TextField)`
  & input {
    padding: 8px;
    width: 525px;
    border-radius: 8px;
    background: #fff9e4;
    height: 29px;
  }
  & input:-webkit-autofill {
    /* Styles for autofill */
    width: 525px;
    border-radius: 8px;
    height: 29px;
    box-shadow: 0 0 0 30px #fff9e4 inset !important;
  }
  & fieldset {
    border-style: unset;
  }
`;

interface LoginForm {
  username: string;
  password: string;
  rememberMe: boolean;
}

export default function Login(props: loginProps): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  // const [isAdding, setIsAdding] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    username: "",
    password: "",
  });
  const userName = sessionStorage.getItem("user-name");

  const [loginForm, setLoginForm] = useState<LoginForm>({
    username: "",
    password: "",
    rememberMe: false,
  });
  const [showLoginForm, setShowLoginForm] = useState<boolean>(true);
  const [showForgotPassword, setShowForgotPassword] = useState<boolean>(false);
  const [showForgotUsername, setShowForgotUsername] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState(false);
  const [disableUsername, setDisableUsername] = useState<boolean>(false);
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  
const activateUserRole = async (userRoles: any, defaultRoleName: string) => {
  const userRole = userRoles?.find((role: any) => role?.roleName === defaultRoleName)
  try {
    await apiRequest({
      method: "POST",
      endpoint: apiPath.activateRole?.replace(
        "{0}",
        JSON.stringify(userRole.roleId)
      ),
      includeToken: true,
    })
  } catch (error) {
    // Handle errors, such as displaying an error message
    toast.custom(
      <ErrorPopup
        showMessage={catchErrorMessageHandler(error)}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />,
      {
        duration: constants.TOAST_POPUP_DURATION,
      }
    );
  }
};
  const getUserDefaultRole = () => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.userRolesInfo}`,
      includeToken: true,
      params: {
        username: loginForm.username.toUpperCase(),
      },
    })
      .then((res) => {
        sessionStorage.setItem("name", res.data.fullName);
        sessionStorage.setItem("firstAndLastName", res.data.firstAndLastName);
        const rolesJsonString = JSON.stringify(res.data.roles);
        sessionStorage.setItem("user-roles", rolesJsonString);

        sessionStorage.setItem("selectedRole", res.data.defaultRole);
        activateUserRole(res.data.roles, res.data.defaultRole);

        const defaultRoleObj = res.data.roles.find(
          (role: roleListProps) => role.roleName === res.data.defaultRole
        );
        // Store the default role ID
        if (defaultRoleObj) {
          sessionStorage.setItem(
            "userRoleId",
            defaultRoleObj.roleId.toString()
          );
        }
        handleClose();
        setLoading(false);
        if(constants.showDashBoardForRoles.includes(res.data.defaultRole)) {
          navigate(
            `/managerDashboard/devoteeservice/${SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS}`
          );
        } else {
          navigate(RoutingURLs.dashboard);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        sessionStorage.clear();
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  const handleSubmit = (e: any): void => {
    e.preventDefault();
    let usernameError = "";
    let passwordError = "";

    if (!loginForm.username) {
      usernameError = "Username is required";
    }
    if (!loginForm.password) {
      passwordError = "Password is required";
    }

    setErrorMessage({
      username: usernameError,
      password: passwordError,
    });

    if (!usernameError && !passwordError) {
      const userLoginDetails: any = {
        username: loginForm.username,
        password: loginForm.password,
      };
      var formBody: any = [];
      for (var property in userLoginDetails) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(userLoginDetails[property]);
        formBody.push(encodedKey + "=" + encodedValue);
      }

      formBody = formBody.join("&");
      setDisableUsername(true);
      setLoading(true);
      apiRequest({
        method: "POST",
        endpoint: apiPath.loginPath,
        body: formBody,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      })
        .then((res) => {
          formReset();
          setDisableUsername(false);
          sessionStorage.clear();
          sessionStorage.setItem("username", loginForm.username);
          sessionStorage.setItem("user-token", res.data.accessToken);
          getUserDefaultRole();
        })
        .catch((err: any) => {
          setLoading(false);
          console.log(err);
          setDisableUsername(false);
          toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
            duration: constants.TOAST_POPUP_DURATION,
          });
        });
    }
  };

  // const saveCredentialsToLocalStorage = (username: any, password: any) => {
  //    localStorage.setItem('rememberMe', 'true');
  //    localStorage.setItem('username', username);
  //    localStorage.setItem('password', password);
  // };

  const goToRegister = (): void => {
    setOpen(false);
    navigate("/register");
  };

  const handleClickOpen = (): void => {
    setOpen(true);
    setShowLoginForm(true);
    setShowForgotUsername(false);
    setShowForgotPassword(false);
  };

  const handleClose = (): void => {
    setOpen(false);
    formReset();
    setErrorMessage({
      username: "",
      password: "",
    });
    setShowLoginForm(true);
    setShowForgotUsername(false);
    setShowForgotPassword(false);
  };

  const handleFieldChange = (field: any, value: any) => {
    setLoginForm({
      ...loginForm,
      [field]: value,
    });

    // Check if the field being changed is the "Remember Me" checkbox
    // if (field === 'rememberMe' && value) {
    //    saveCredentialsToLocalStorage(loginForm.username, loginForm.password);
    // }
  };

  const formReset = (): void => {
    setLoginForm({
      username: "",
      password: "",
      rememberMe: false,
    });
  };

  const handleForgotPassword = (): void => {
    setShowForgotPassword(true);
    setShowLoginForm(false);
  };

  const handleForgotUsername = (): void => {
    setShowForgotUsername(true);
    setShowLoginForm(false);
  };

  const loginFormComponent = (): React.ReactElement => {
    const validatePasswordLength = (password: string) => {
      const maxLength = 16;

      if (password.length > maxLength) {
        return `Password must be between  9 to ${maxLength} characters.`;
      }
      return "";
    };
    const handleKeyDownuser = (e: any, fieldName: string) => {
      if (!/[0-9a-zA-Z_]/.test(e.key)) {
        e.preventDefault();
      }
    };
    return (
      <>
        <form className={styles.Form} onSubmit={handleSubmit}>
          <Typography variant="h4" component="h4" align="left">
            Login
          </Typography>
          <Typography sx={{ marginBottom: "30px" }}>
            Enter your credentials to access your account
          </Typography>
          <Grid xs={12} item>
            {CustomRequiredInputLabel(
              userName != null ? userName : "User Name",
              true
            )}
            <CustomTextField
              fullWidth={true}
              value={loginForm.username}
              style={{ borderColor: errorMessage.username ? "red" : "" }}
              // onChange={(e) => {
              //   setErrorMessage({ ...errorMessage, username: "" });
              //   handleFieldChange("username", e.target.value);
              // }}
              onChange={(e) => {
                const inputUserName = e.target.value;
                if (inputUserName.length <= 10 && !/\s/.test(inputUserName)) {
                  // Check length and absence of spaces
                  setErrorMessage({ ...errorMessage, username: "" });
                  handleFieldChange("username", inputUserName);
                } else {
                  setErrorMessage({
                    ...errorMessage,
                    username: "Username must be 4 to 10 characters.",
                  });
                }
              }}
              onBlur={() => {
                const inputUserName = loginForm.username.toUpperCase();
                handleFieldChange('username', inputUserName);
              }}
              onKeyDown={(e) => handleKeyDownuser(e, "userName")}
              className={
                errorMessage.username ? styles.errorTextField : styles.textField
              }
              InputProps={{
                readOnly: disableUsername,
              }}
            />
            {errorMessage.username ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.username}
              </Typography>
            ) : (
              ""
            )}
            <Box sx={{ textAlign: "right" }}>
              <Link
                variant="body2"
                sx={{
                  color: "#F05802",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={handleForgotUsername}
              >
                Forgot Username?
              </Link>
            </Box>
          </Grid>
          <Grid xs={12} item>
            {CustomRequiredInputLabel("Password", true)}
            <CustomTextField
              sx={{ background: "#fff9e4" }}
              fullWidth={true}
              required={true}
              value={loginForm.password}
              onChange={(e) => {
                const newPassword = e.target.value;
                const validationError = validatePasswordLength(newPassword);
                if (validationError) {
                  setErrorMessage({
                    ...errorMessage,
                    password: validationError,
                  });
                } else {
                  setErrorMessage({ ...errorMessage, password: "" });
                  handleFieldChange("password", newPassword);
                }
              }}
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? (
                        <VisibilityOutlinedIcon />
                      ) : (
                        <VisibilityOffOutlinedIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              className={
                errorMessage.password ? styles.errorTextField : styles.textField
              }
            />
            {errorMessage.password ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessage.password}
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid xs={12} item>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <FormControlLabel
                control={
                  <Checkbox value={loginForm.rememberMe} color="warning" />
                }
                label="Remember me"
              />
              <Typography
                variant="body2"
                sx={{
                  color: "#F05802",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={handleForgotPassword}
              >
                Forgot Password?
              </Typography>
            </Box>
          </Grid>
          <Grid xs={12} item>
            <CommonButton
              type="submit"
              fullWidth={true}
              variant="contained"
              style={loginScreen.buttonSize}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Login"
              )}
            </CommonButton>
            <CommonOutlinedButton
              fullWidth={true}
              onClick={goToRegister}
              style={loginScreen.buttonSize}
            >
              {" "}
              Register
            </CommonOutlinedButton>
          </Grid>
        </form>
      </>
    );
  };


  return (
    <div>
      <Toaster />
      <Button
        style={{
          backgroundColor: "#FFF9E4",
          color: "#882E14",
          borderRadius: "4px",
          fontWeight: "600",
        }}
        variant="contained"
        onClick={handleClickOpen}
      >
        Login
      </Button>
      <Dialog
        style={
          isMobile
            ? {
                padding: "30px",
                backgroundRepeat: "round",
                backgroundImage: `url(${loginBgBanner})`,
              }
            : {}
        }
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="xl"
        PaperProps={{
          style: {
            height: "calc(100% - 64px)",
            width: "calc(100% - 64px)",
            margin: "32px",
            maxWidth: "1000px",
            maxHeight: "644px",
          },
        }}
      >
        <div
          className={styles.closeIcon}
          // style={{ position: 'absolute', top: '15px', right: '18px', cursor: 'pointer' }}
          onClick={handleClose}
        >
          <CustomCloseIcon />
        </div>
        <DialogContent
          style={
            isMobile
              ? { padding: "30px", height: "auto" }
              : loginScreen.contentPadding
          }
        >
          <Grid
            container
            style={
              isMobile
                ? { height: "100%", alignItems: "center", display: "flex", flexDirection: "column", marginTop: "40px" }
                : loginScreen.userForm
            }
          >
            <Grid
              item
              xs={6}
              component="form"
              noValidate
              sx={
                isMobile
                  ? { width: "100%", maxWidth: "100%" }
                  : loginScreen.formPadding
              }
            >
              {showLoginForm ? loginFormComponent() : ""}
              {showForgotPassword ? (
                <ForgotPassword
                  setShowLoginForm={setShowLoginForm}
                  setShowForgotPassword={setShowForgotPassword}
                  setShowError={setShowError}
                  setOpen={setOpen}
                />
              ) : (
                ""
              )}
              {showForgotUsername ? (
                <ForgotUsername
                  setShowLoginForm={setShowLoginForm}
                  setShowForgotUsername={setShowForgotUsername}
                  setShowError={setShowError}
                />
              ) : (
                ""
              )}
              {/* {showError ? (
                        <LoginError
                           setShowLoginForm={setShowLoginForm}
                           errorMessage={errMessage}
                           setShowError={setShowError}
                        />
                     ) : (
                        ''
                     )} */}
            </Grid>
            {/* <LoginRightBanner handleDonateClick={props.handleClickDonation} setLoginOpen={setOpen} /> */}
            {!isMobile && (
              <LoginRightBanner
                handleDonateClick={props.handleClickDonation}
                setLoginOpen={setOpen}
              />
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export const LoginRightBanner = (props: LoginRightBannerProps) => {
  return (
    <Grid item xs={6}>
      <Box style={loginScreen.bannerStyle} position="relative">
        <Typography
          color="white"
          align="center"
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "300px",
            marginLeft: "auto",
            marginRight: "auto",
            fontSize: "18px",
            paddingTop: "20px",
          }}
        >
          {"Welcome to"} <br /> {"HCCC"} <br />{" "}
          {"Shiva-Vishnu Temple , Livermore"}
        </Typography>
        {/* 
        <Box sx={{ width: "100%", position: "absolute", bottom: "3%" }}>
          <img
            src="/images/Login_Banner_Ribbon.svg"
            style={{ width: "100%", position: "absolute", bottom: "7%" }}
          />

          <CommonButton
            sx={{
              marginLeft: "90%",
              position: "relative",
              transform: "translateX(-50%)",
              bottom: "70%",
              marginBottom: "30px",
            }}
            onClick={() => {
              props.handleDonateClick?.();
              props.setLoginOpen?.(false);
            }}
          >
            Donate
          </CommonButton>
        </Box> */}
      </Box>
    </Grid>
  );
};
